import React, { useEffect, useState } from "react";
import Icon from "../Icon";
import classNames from "classnames";
import Text from "../Text";

const EmailInput = ({
  isDisable,
  onChangeHandler,
  label = "Email",
  placeholder = "",
  showIcon = false,
  value = "",
  isRequired = false,
}) => {
  const [email, setEmail] = useState("");
  const [isInvalidEmail, setIsInvalidEmail] = useState(true);
  const [error, setError] = useState("");
  // const [error, setError] = useState("Invalid email! Please Try Again.");

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setEmail(email);
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (regex.test(email)) {
      setIsInvalidEmail(false);
      onChangeHandler(email);
    } else {
      setIsInvalidEmail(true);
    }
  };

  useEffect(() => {
    if (value) {
      setEmail(value);
    }
  }, []);

  return (
    <div
      className={classNames("relative w-full", {
        "pointer-events-none": isDisable,
      })}
    >
      <div
        className={classNames(
          "flex flex-row items-center h-14 justify-center pl-12 border border-senate rounded-[4px] overflow-hidden font-encode-sans gap-3",
          {
            "!border-infrared-burn": error,
          }
        )}
      >
        {showIcon ? (
          <Icon type="user" height="24px" width="24px" color="#5F6368" />
        ) : null}
        <input
          type="text"
          name="email"
          className={classNames(
            "text-gray-dark peer block w-full mr-16 px-0 py-16 text-sm focus:outline-none focus:ring-0 placeholder:text-senate !placeholder:text-16 !placeholder:font-encode-sans !placeholder:font-normal"
          )}
          maxLength={50}
          placeholder={placeholder}
          onChange={handleEmailChange}
          value={email}
        />
      </div>
      <label
        className={classNames(
          "absolute top-[17px] font-encode-sans left-3 text-14 font-medium text-senate leading-16 tracking-[0.24px] bg-white duration-300 transform -translate-y-6 px-[6px]",
          {
            "!text-infrared-burn": error,
          }
        )}
      >
        {label}
        {isRequired ? (
          <Text type="span" className="!text-infrared-burn">
            *
          </Text>
        ) : null}
      </label>

      {error ? (
        <Text
          type="span"
          className="font-encode-sans text-14 text-infrared-burn font-medium leading-4 track-[0.24px] px-16"
        >
          {error}
        </Text>
      ) : null}
    </div>
  );
};

export default EmailInput;